import { dateProvider } from '@utils';
import { Trans, useTranslation } from 'react-i18next';

import {
  AlertMessage,
  AlertMessageContent,
  AlertMessageText,
  AlertMessageTitle,
  CardsGrid,
  InfoCard,
  InfoCardContent,
  InfoCardIcon,
  InfoCardLabel,
  InfoCardValue
} from './ConfirmPlanification.styles';

import { Icon } from '@/components/Icon';
import { LoadingBar } from '@/components/Loaders';
import { ColoredText, StepWrapper, TitleText } from '@/pages/Student/Onboarding/styles';
import { useMyPlanification } from '@/store';
import { formatSecondsInHoursAndMinutes } from '@/utils';

export const ConfirmPlanification = () => {
  const { t } = useTranslation(['DefaultTranslations', 'StudentProfileConfigurationTranslations']);
  const { planification, isLessThanMinTime, isMaxTimeExceeded, isLoading } = useMyPlanification();

  if (isLoading || !planification) {
    return <LoadingBar />;
  }

  const { hours, minutes } = formatSecondsInHoursAndMinutes(planification.dailyStudyTime);
  const isCorrectTime = !isLessThanMinTime && !isMaxTimeExceeded;

  const daysDiff = dateProvider.diff(new Date(), planification.endDate, 'days');

  return (
    <StepWrapper>
      <TitleText>
        <Trans
          i18nKey="DefaultTranslations:ONBOARDING_DESIGN_STUDY_PLAN"
          components={{ span: <ColoredText /> }}
        />
      </TitleText>

      {(isLessThanMinTime || isMaxTimeExceeded) && (
        <AlertMessage $variant="warning">
          <Icon i="WarningAltFilled" color="orange6" size={20} />
          <AlertMessageContent>
            <AlertMessageTitle>
              {t('DefaultTranslations:PLANIFICATION_RESULT_ALERT_MESSAGE_TITLE_WARNING')}
            </AlertMessageTitle>
            <AlertMessageText>
              {t('DefaultTranslations:PLANIFICATION_RESULT_ALERT_MESSAGE_CONTENT_WARNING')}
            </AlertMessageText>
          </AlertMessageContent>
        </AlertMessage>
      )}

      {isCorrectTime && (
        <AlertMessage $variant="success">
          <Icon i="CheckmarkFilled" color="green6" size={20} />
          <AlertMessageContent>
            <AlertMessageTitle>
              {t('DefaultTranslations:PLANIFICATION_RESULT_ALERT_MESSAGE_TITLE_SUCCESS')}
            </AlertMessageTitle>
            <AlertMessageText>
              {t('DefaultTranslations:PLANIFICATION_RESULT_ALERT_MESSAGE_CONTENT_SUCCESS')}
            </AlertMessageText>
          </AlertMessageContent>
        </AlertMessage>
      )}

      <CardsGrid>
        <InfoCard>
          <InfoCardIcon>
            <Icon i="Event" color="purple6" size={20} />
          </InfoCardIcon>
          <InfoCardContent>
            <InfoCardLabel>{t('StudentProfileConfigurationTranslations:END_DATE')}</InfoCardLabel>
            <InfoCardValue>
              {dateProvider.format(planification.endDate, 'dd/MM/yyyy')} (
              {t('DefaultTranslations:DAYS_other', { count: daysDiff })})
            </InfoCardValue>
          </InfoCardContent>
        </InfoCard>

        <InfoCard>
          <InfoCardIcon>
            <Icon i="Time" color="purple6" size={20} />
          </InfoCardIcon>
          <InfoCardContent>
            <InfoCardLabel>
              {t('DefaultTranslations:ONBOARDING_RECOMMENDED_STUDY_PER_DAY')}
            </InfoCardLabel>
            <InfoCardValue>
              {hours} {t('DefaultTranslations:HOURS_BASIC')}, {minutes}{' '}
              {t('DefaultTranslations:MINUTES_BASIC')}
            </InfoCardValue>
          </InfoCardContent>
        </InfoCard>
      </CardsGrid>
    </StepWrapper>
  );
};
